import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export const LOGIN_URL = `${API_URL}/login`
export const GET_USER_BY_ACCESSTOKEN_URL = `${LOGIN_URL}/verify-token`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${LOGIN_URL}/forgot-password`
export const REQUEST_EMAIL_VALIDATE = `${LOGIN_URL}/check-email-validate`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post(LOGIN_URL, {
    email,
    password,
  }).then((res:any)=>{
    return res
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

// export function getUserByToken(token: any) { 
//   console.log("token api GET_USER_BY_ACCESSTOKEN_URL", token )
//   return axios.post(GET_USER_BY_ACCESSTOKEN_URL, {
//     token: token,
//   })
// }
export function getUserByToken(token: any) {
  console.log("Function getUserByToken called");
  console.log("Received token: Apiiiii", token);

  const payload = { token: token };
  console.log("Request payload:Apiiiii ", payload);

  console.log("POST URL:Apiiiii", GET_USER_BY_ACCESSTOKEN_URL);

  return axios.post(GET_USER_BY_ACCESSTOKEN_URL, payload)
    .then(response => {
      console.log("API response:Apiiiii", response);
      return response;
    })
    .catch(error => {
      console.log("API error:Apiiiii", error);
      throw error;
    });
}

export function checkEmailValidate(email: string) {
  return axios.post<{result: boolean}>(REQUEST_EMAIL_VALIDATE, {
    email,
  })
}